import React from 'react';
import { FileText, Shield, Zap, Users } from 'lucide-react';

const categories = [
  {
    title: "Blog Posts",
    examples: ["How to Guide", "Top 10 List", "Ultimate Guide"],
    description: "Engaging titles for blog content and articles."
  },
  {
    title: "E-commerce Pages",
    examples: ["Product Pages", "Category Pages", "Landing Pages"],
    description: "Conversion-focused titles for online stores."
  },
  {
    title: "Business Sites",
    examples: ["Service Pages", "About Pages", "Contact Pages"],
    description: "Professional titles for business websites."
  }
];

const tips = [
  {
    icon: FileText,
    title: "Use Keywords",
    content: "Include relevant keywords naturally in your titles."
  },
  {
    icon: Shield,
    title: "Stay Concise",
    content: "Keep titles under 60 characters for optimal display."
  },
  {
    icon: Zap,
    title: "Be Specific",
    content: "Clearly describe your page content."
  },
  {
    icon: Users,
    title: "Know Your Audience",
    content: "Write titles that appeal to your target readers."
  }
];

export default function MetaGuide() {
  return (
    <section className="py-20 bg-emerald-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="text-3xl font-bold text-center text-gray-900 mb-12">
          Complete Guide to Meta Titles
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
          {categories.map((category, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-xl font-semibold text-gray-900 mb-4">{category.title}</h3>
              <ul className="space-y-2 mb-4">
                {category.examples.map((example, i) => (
                  <li key={i} className="text-emerald-600">{example}</li>
                ))}
              </ul>
              <p className="text-gray-600">{category.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-white p-8 rounded-lg shadow-md">
          <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">
            Tips for Writing Meta Titles
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {tips.map((tip, index) => (
              <div key={index} className="text-center">
                <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-emerald-100 mb-4">
                  <tip.icon className="w-6 h-6 text-emerald-600" />
                </div>
                <h4 className="text-lg font-semibold text-gray-900 mb-2">{tip.title}</h4>
                <p className="text-gray-600">{tip.content}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}